export default __webpack_public_path__ + "static/media/Bhojpuri_agri1_m.3c7c27de.wav";